import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import store from 'surface_mount_carriers/store';
import App from 'surface_mount_carriers/App';
import Cart from 'surface_mount_carriers/Cart';

document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.getElementById('quote-form');
  const cartContainer = document.getElementById('cart-form');

  if (appContainer != null) {
    render(
      <Provider store={store} >
        <App />
      </Provider>,
      appContainer
    );
  }

  if (cartContainer) {
    render(
      <Provider store={store} >
        <Cart />
      </Provider>,
      cartContainer
    );
  }
});
